import { render, staticRenderFns } from "./NavNotifications.vue?vue&type=template&id=404c2791"
import script from "./NavNotifications.vue?vue&type=script&lang=ts"
export * from "./NavNotifications.vue?vue&type=script&lang=ts"
import style0 from "./NavNotifications.vue?vue&type=style&index=0&id=404c2791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports